import { render, staticRenderFns } from "./ProfileSelector.vue?vue&type=template&id=db237f44&scoped=true&"
import script from "./ProfileSelector.vue?vue&type=script&lang=js&"
export * from "./ProfileSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSelector.vue?vue&type=style&index=0&id=db237f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db237f44",
  null
  
)

export default component.exports